  import {Dropdown} from 'antd';
  import React, {useEffect} from 'react';
  import {CheckIcon, DownIcon} from './components/SvgIcons/SvgIcons';

  const CustomSelect = ({
    handleGetMyIntro,
    handleIntroAll,
    handleIntroCompleted,
    introFilter,
    introAll,
    handleIntroActive,
    introActive,
    introCompleted,
  }) => {
    return (
      <div className="custom-menu">
        <Dropdown
          overlay={
            <SelectList
              handleGetMyIntro={handleGetMyIntro}
              handleIntroAll={handleIntroAll}
              handleIntroActive={handleIntroActive}
              handleIntroCompleted={handleIntroCompleted}
              introFilter={introFilter}
              introAll={introAll}
              introActive={introActive}
              introCompleted={introCompleted}
            />
          }
          placement="bottomRight"
          trigger={['click']}>
          {introAll ? (
            <button className="active-btn">
              View All
              <DownIcon />
            </button>
          ) : introActive ? (
            <button className="active-btn">
              Active
              <DownIcon />
            </button>
          ) : (
            <button className="active-btn">
              Completed
              <DownIcon />
            </button>
          )}
        </Dropdown>
      </div>
    );
  };

  export default CustomSelect;

  export const SelectList = ({
    handleGetMyIntro,
    handleIntroAll,
    handleIntroCompleted,
    introFilter,
    introAll,
    handleIntroActive,
    introActive,
    introCompleted,
  }) => { 
    useEffect(() => {
      handleGetMyIntro();
    }, [introFilter]);

    return (
      <div className="select-list-wrapper">
        <div className="select-list-menu" onClick={() => handleIntroAll()}>
          {introAll ? <CheckIcon /> : null}
          <p>View all</p>
        </div>
        <div className="select-list-menu" onClick={() => handleIntroActive()}>
          {introActive ? <CheckIcon /> : null} <p>Active</p>
        </div>
        <div className="select-list-menu" onClick={() => handleIntroCompleted()}>
          {introCompleted ? <CheckIcon /> : null} <p>Completed</p>
        </div>
      </div>
    );
  };
